/* global axios */
import ApiClient from './ApiClient';

// Assinatura pela conversa (Minutas, Fase 1). Manual: docs/minutas/ASSINATURA.md.
// `conversationId` é o número da conversa na tela (display_id).
class AssinaturasAPI extends ApiClient {
  constructor() {
    super('assinaturas', { accountScoped: true });
  }

  // A tela Assinaturas do módulo: grupo (aba), q (busca), pagina.
  lista({ grupo, q, pagina } = {}) {
    return axios.get(this.url, { params: { grupo, q, pagina } });
  }

  numeros() {
    return axios.get(`${this.url}/numeros`);
  }

  conversaDoContato(contactId) {
    return axios.get(`${this.url}/conversa_do_contato`, {
      params: { contact_id: contactId },
    });
  }

  daConversa(conversationId) {
    return axios.get(this.url, { params: { conversation_id: conversationId } });
  }

  preparo(conversationId) {
    return axios.get(`${this.url}/preparo`, {
      params: { conversation_id: conversationId },
    });
  }

  // Os dados que vão no contrato de quem conversa (o bloco do passo 1).
  contratante(conversationId) {
    return axios.get(`${this.url}/contratante`, {
      params: { conversation_id: conversationId },
    });
  }

  salvarContratante(conversationId, dados) {
    return axios.patch(`${this.url}/contratante`, {
      ...dados,
      conversation_id: conversationId,
    });
  }

  // O menor que a pessoa da conversa representa, cadastrado na gaveta.
  representado(conversationId, { nome, cpf, nascimento, genero, grau }) {
    return axios.post(`${this.url}/representado`, {
      conversation_id: conversationId,
      nome,
      cpf,
      nascimento,
      genero,
      grau,
    });
  }

  completarCadastro(conversationId, { cpf, email }) {
    return axios.patch(`${this.url}/cadastro`, {
      conversation_id: conversationId,
      cpf,
      email,
    });
  }

  previaDaBolha(conversationId, { mensagem, documentos }) {
    return axios.get(`${this.url}/previa`, {
      params: {
        conversation_id: conversationId,
        formato: 'bolha',
        mensagem,
        documentos,
      },
    });
  }

  // O PDF de prévia de um modelo, já com os dados do cliente. Vem como
  // arquivo (a aba nova não levaria o token de acesso).
  previaPdf(conversationId, templateId, campos = {}, legalProcessId = null) {
    return axios.get(`${this.url}/previa`, {
      params: {
        conversation_id: conversationId,
        template_id: templateId,
        campos,
        legal_process_id: legalProcessId || undefined,
      },
      responseType: 'blob',
    });
  }

  enviar(conversationId, dados) {
    return axios.post(this.url, { conversation_id: conversationId, ...dados });
  }

  ler(id) {
    return axios.get(`${this.url}/${id}`);
  }

  link(id) {
    return axios.get(`${this.url}/${id}/link`);
  }

  // O link de assinatura de quem está logado (o advogado que assina junto).
  meuLink(id) {
    return axios.get(`${this.url}/${id}/meu_link`);
  }

  acao(id, nome) {
    return axios.post(`${this.url}/${id}/${nome}`);
  }
}

export default new AssinaturasAPI();
